<template>
    <div class="gym">
        <div class="toolbar" style="margin-bottom:20px;display:flex;align-items:center;justify-content:flex-start;">
            <div class="operation" style="display: flex;align-items: center;justify-content: flex-start;">
                <el-input size="small" class="search-ipt" v-model="cdit" placeholder="请输入场馆名称或联系电话,或连锁品牌" clearable @change="onSearchClick">
                    <el-button slot="append" class="search-btn" type="success" @click="onSearchClick">查询</el-button>
                </el-input>
                <el-button size="small" class="add-btn" type="primary" icon="el-icon-plus" @click="showAddModal = true">
                    新增
                </el-button>
            </div>
            <div class="filters">
                <el-radio-group size="small" v-model="status" @change="onSearchClick">
                    <el-radio-button label="">全部</el-radio-button>
                    <el-radio-button label="0">删除</el-radio-button>
                    <el-radio-button label="9">停止营业</el-radio-button>
                    <el-radio-button label="1">正常</el-radio-button>
                </el-radio-group>
            </div>
        </div>

        <el-table :data="list" style="width: 100%" v-loading="loading" size="small" class="mb12">
            <el-table-column type="index" width="60" :index="(index) => index + 1 + pageStart" label="序号" />
            <el-table-column label="连锁品牌">
                <template slot-scope="scope">
                    <div v-if="scope.row.group_sn">
                        <div class="txtrow" style="display: flex;align-items: center;justify-content: flex-start;">
                            认证码：{{scope.row.group_sn}}
                            <el-button v-if="scope.row.is_flagship" type="text" class="fc_golden txtrow" style="margin-left:5px;display: flex;align-items: center;justify-content: flex-start;" @click="goOutFlagship(scope.row.id)"><i class="el-icon-s-flag"></i>总部</el-button>
                            <el-button v-else type="text" class="txtrow" style="padding:0;margin-left:5px;" @click="outGroup(scope.row.id)">退出</el-button>
                        </div>
                        <div class="txtrow" style="display: flex;align-items: center;justify-content: flex-start;">
                            品牌名：<el-button type="text" class="txtrow" style="padding:0;" @click="changeGroupName(scope.row.id,scope.row.group_name,scope.row.is_flagship)">{{scope.row.group_name}}</el-button>
                        </div>
                    </div>
                    <div v-else>
                        <el-button size="mini" round @click="newGroup(scope.row.id)">创建总部</el-button>
                        <el-button type="primary" size="mini" round @click="inGroup(scope.row.id)">加入连锁</el-button>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="名称｜联系方式">
                <template slot-scope="scope">
                    <div class="txtrow">{{scope.row.name}}</div>
                    <div v-if="scope.row.tel_no || scope.row.tel_name" class="txtrow">{{scope.row.tel_no?scope.row.tel_no:''}} {{scope.row.tel_name ? scope.row.tel_name : ''}}</div>
                </template>
            </el-table-column>
            <el-table-column label="手机端会员｜教练｜员工">
                <template slot-scope="scope">
                    <div class="txtrow">{{scope.row.vip_count}}人｜{{scope.row.trainer_count}}人｜{{scope.row.adminer_count}}人</div>
                    <el-button type="text" style="padding:3px 0;" @click="toSetMobSu(scope.row.id,scope.row.mob_supers)">
                        手机端超级员工
                        <span v-if="scope.row.mob_supers.length>3">3<sup>+</sup></span>
                        <span v-else>{{scope.row.mob_supers.length}}</span>
                        <span>人</span>
                    </el-button>
                </template>
            </el-table-column>
            <el-table-column label="场馆后台超级管理员">
                <template slot-scope="scope">
                    <div v-if="scope.row.supers && scope.row.supers.length">
                        <div v-if="scope.row.supers.length>3">
                            <div v-for="ix in 3" :key="ix">
                                <el-button type="text" class="txtrow" style="padding:2px 0;" @click="goSetSu(scope.row.supers[ix])">{{scope.row.supers[ix].name+' '+scope.row.supers[ix].phoneno}}</el-button>
                            </div>
                        </div>
                        <div v-else="scope.row.supers.length>1">
                            <div v-for="(item,ix) in scope.row.supers" :key="ix">
                                <el-button type="text" class="txtrow" style="padding:2px 0;" @click="goSetSu(item)">{{item.name+' '+item.phoneno}}</el-button>
                            </div>
                        </div>
                    </div>
                    <el-button type="text" style="padding:3px 0;" @click="gym_id_su=scope.row.id;showAddModalSu = true;">
                        新增超管
                        <span v-if="scope.row.supers.length>3">3<sup>+</sup></span>
                        <span v-else>{{scope.row.supers.length}}</span>
                        <span>人</span>
                    </el-button>
                </template>
            </el-table-column>
            <el-table-column label="业务授权与状态">
                <template slot-scope="scope">
                    <el-button type="text" style="text-align:left;" @click="toSetGymBus(scope.row.id)">
                        <div class="txtrow"><span :class="1>scope.row.status ? 'colorred' : (1==scope.row.status ? 'colorgreen' : (9==scope.row.status ? 'colororange' :''))">{{1>scope.row.status ? '删除' : (1==scope.row.status ? '正常' : (9==scope.row.status ? '停业' : ''))}}</span> | 业务授权 {{1==scope.row.busiunit_auth_isallin?'所有':scope.row.busiunits_count+'项'}}</div>
                    </el-button>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="250" align="center">
                <template slot-scope="scope">
                    <el-button-group v-if="1==scope.row.is_flagship">
                        <el-button type="default" size="small" @click="toSortGroupGyms(scope.row.id)">连锁场馆排序</el-button>
                    </el-button-group>
                    <el-button-group v-else>
                        <el-button v-bind:disabled="scope.row.status == 0" type="default" size="small" @click="goSet(scope.row)">修改</el-button>
                        <el-button v-bind:disabled="scope.row.status == 0" type="danger" size="small" @click="handleGymStatus(scope.row.id, 0)">删除</el-button>
                        <el-button v-bind:disabled="scope.row.status == 9" type="warning" size="small" @click="handleGymStatus(scope.row.id, 9)">停业</el-button>
                        <el-button v-bind:disabled="scope.row.status == 1" type="success" size="small" @click="handleGymStatus(scope.row.id, 1)">正常</el-button>
                    </el-button-group>
                </template>
            </el-table-column>
        </el-table>
        <div class="bottom-toolbar" style="display: flex;align-items: center;justify-content: flex-start;">
            <div class="fc_gray fs_small">每页</div>
            <el-select v-model="page_size" size="mini" placeholder="请选择每页行数" style="width:75px;margin:0 5px;" @change="onPageSizeChange">
                <el-option v-for="item in page_size_opts" :key="item" :label="item" :value="item"></el-option>
            </el-select>
            <div class="fc_gray fs_small">行</div>
            <div class="pagination">
                <el-pagination background layout="prev, pager, next" :total="total" :page-size="page_size" v-if="total > page_size" @current-change="onPageChange" :current-page.sync="page_ix">
                </el-pagination>
            </div>
        </div>

        <el-dialog class="form-wrap" :title="showAddModal ? '新增场馆' : '修改场馆'" :visible.sync="showModal" :before-close="onCloseModal">
            <el-form @submit.native.prevent ref="gym-form" :rules="rule" :model="gymOnSet" label-position="left" style="min-width: 600px; padding: 30px 10px">
                <el-row :gutter="20">
                    <el-col :span="10" :offset="1">
                        <el-form-item label="名称" prop="name">
                            <el-input v-model="gymOnSet.name" />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="10" :offset="1">
                        <el-form-item label="联系电话" prop="tel_no">
                            <el-input v-model="gymOnSet.tel_no" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="10" :offset="2">
                        <el-form-item label="联系人" prop="tel_name">
                            <el-input v-model="gymOnSet.tel_name" />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row v-if="showAddModal" :gutter="20" class="border bc_golden_bright" style="margin-bottom:25px;padding-top:25px;">
                    <el-col :span="22" :offset="1">
                        <div class="fc_red" style="margin-bottom: 10px;">注意：品牌<span class="fs_large bold">总部</span>一旦创建，将不能删除或更改！！！<span class="fs_large bold">总部</span>为连锁统一提供动作、课程等资源支持！！！</div>
                    </el-col>
                    <el-col :span="10" :offset="1">
                        <el-form-item label="">
                            <div style="display: flex;align-items: center;justify-content: flex-start;">
                                <div style="margin-right:25px;">创建品牌总部</div>
                                <el-radio-group v-model="gymOnSet.is_flagship">
                                    <el-radio :label="1">是</el-radio>
                                    <el-radio :label="0">否</el-radio>
                                </el-radio-group>
                            </div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="10" :offset="2">
                        <el-form-item label="">
                            <el-input v-model="gymOnSet.group_name" placeholder="品牌名" />
                        </el-form-item>
                    </el-col>
                </el-row>
                <!-- <el-row v-else-if="gymOnSet.group_sn" :gutter="20" class="border bc_golden_bright" style="margin-bottom:25px;padding-top:25px;">
					<el-col :span="10" :offset="1">
						<el-form-item label="" prop="group_sn">
							<div style="display: flex;align-items: center;justify-content: space-between;">
								<div>连锁品牌名<small class="fc_gray">（{{gymOnSet.group_sn}}）</small></div>
								<el-button type="text" style="margin-left:25px;" @click="outGroup">退出</el-button>
							</div>
							<div>
								<el-input v-model="gymOnSet.group_name" />
							</div>
						</el-form-item>
					</el-col>
					<el-col :span="10" :offset="2">
						<el-form-item label="是否总部">
							<el-radio-group v-model="gymOnSet.is_flagship" style="width: 100%;">
								<el-radio :label="1">是</el-radio>
								<el-radio :label="0">否</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
				</el-row> -->
                <el-row :gutter="20" style="margin-top:50px;">
                    <el-col :span="22" :offset="1">
                        <el-form-item label="" style="float: right;">
                            <el-button plain @click="onCloseModal">取消</el-button>
                            <el-button type="primary" @click="onSave">保存</el-button>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </el-dialog>

        <el-dialog class="form-wrap" title="手机端超级员工" width="25%" :visible.sync="showModalMobSu" :before-close="onCloseModalMobSu">
            <div class="fc_gray fs_small">当前手机端超级员工</div>
            <el-table :data="mob_su_list" size="mini" style="margin-bottom:25px;">
                <el-table-column property="user.name" label="姓名"></el-table-column>
                <el-table-column property="user.phoneno" label="手机号"></el-table-column>
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" size="mini" style="color:red;" @click="doRmMobSu(scope.row.id)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-form @submit.native.prevent ref="mob-su-form" :rules="rule_mob_su" :model="mobSuOnSet" label-position="left">
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="手机号搜索新增手机端超级员工" prop="phoneno">
                            <el-input v-model="mobSuOnSet.phoneno">
                                <el-button slot="append" icon="el-icon-search" @click="getMobSu"></el-button>
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col v-if="mob_su_searched_str" :span="24">
                        <el-form-item :label="'姓名 '+mob_su_searched_str" prop="name">
                            <el-input v-model="mobSuOnSet.name">
                                <el-button slot="append" icon="el-icon-plus" @click="doSetMobSu"></el-button>
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row style="margin-top:50px;">
                    <el-col :span="24" style="display:flex;align-items: center;justify-content: flex-end;">
                        <el-button plain @click="onCloseModalMobSu">关闭</el-button>
                    </el-col>
                </el-row>
            </el-form>
        </el-dialog>

        <el-dialog class="form-wrap" :title="showAddModalSu ? '新增超级管理员' : '修改超级管理员'" :visible.sync="showModalSu" :before-close="onCloseModalSu">
            <el-form @submit.native.prevent ref="su-form" :rules="rule_su" :model="suOnSet" label-position="left" style="min-width: 600px; padding: 30px 10px">
                <el-row :gutter="20">
                    <el-col :span="10" :offset="1">
                        <el-form-item label="姓名" prop="name">
                            <el-input v-model="suOnSet.name" :placeholder="showAddModalSu?'新增超管不会覆盖已有账号姓名':''" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="10" :offset="2">
                        <el-form-item label="手机号" prop="phoneno">
                            <el-input v-model="suOnSet.phoneno" :disabled="showAddModalSu?false:true" />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20" style="margin-top:50px;">
                    <el-col :span="22" :offset="1" style="display:flex;align-items: center;justify-content: space-between;">
                        <el-form-item label="">
                            <el-button type="danger" :style="{'visibility':(showAddModalSu||!suOnSet.id)?'hidden':'inherit'}" @click="onRemoveSu">删除</el-button>
                            <el-button :style="{'visibility':(showAddModalSu||!suOnSet.id)?'hidden':'inherit'}" @click="resetPW">重置登陆密码</el-button>
                        </el-form-item>
                        <el-form-item label="" style="float: right;">
                            <el-button plain @click="onCloseModalSu">取消</el-button>
                            <el-button type="primary" @click="onSaveSu">保存</el-button>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </el-dialog>

        <el-dialog class="form-wrap" :title="'场馆 '+(bu_gym.abbr_name?bu_gym.abbr_name:bu_gym.name)+' 的业务授权'" fullscreen :visible.sync="show_gym_bu">
            <div style="margin-bottom:10px;display:flex;align-items:center;justify-content:space-between;">
                <div style="display:flex;align-items:center;justify-content:flex-start;">
                    <el-button size="mini" round style="margin-right:25px;" @click="toSetGymBus(bu_gym.id)">重选</el-button>
                    <el-button-group style="margin-right:25px;">
                        <el-button size="mini" round @click="selectBuBlocks('all')">全选</el-button>
                        <el-button size="mini" round @click="selectBuBlocks('none')">不选</el-button>
                        <el-button size="mini" round @click="selectBuBlocks('reverse')">反选</el-button>
                    </el-button-group>
                    <el-button-group style="margin-right:25px;">
                        <el-button v-for="(item,ix) in gym_bu_blocks" :key="ix" size="mini" round @click="selectBuBlocks(item.no)">{{item.name}}</el-button>
                    </el-button-group>
                    <el-button size="mini" :type="gym_bu_auth_isallin?'success':'info'" round :icon="gym_bu_auth_isallin?'el-icon-check':'el-icon-close'" @click="switchBuAuthAllin()">统一授权所有（包括以后增加的）业务</el-button>
                    <el-date-picker v-model="gym_bu_auth_dtm" type="date" :clearable="false" size="mini" placeholder="统一授权有效期" style="width:150px;margin:0 10px;" @change="changeBuAuthDt"></el-date-picker>
                    <el-switch v-model="gym_bu_auth_dt_isuse" :disabled="gym_bu_auth_isallin" active-color="#67C23A" inactive-color="#E4E4E4" active-text="统一以下授权有效期"></el-switch>
                </div>
                <div style="display:flex;align-items:center;justify-content:end;">
                    <div style="display:flex;align-items:center;justify-content:end;">
                        <div style="width:20px;height:4px;background:linear-gradient(to right,green,transparent);"></div>
                        <div>已授权</div>
                    </div>
                    <div style="margin:0 10px;display:flex;align-items:center;justify-content:end;">
                        <div style="width:20px;height:4px;background:linear-gradient(to right,red,transparent);"></div>
                        <div>已过期</div>
                    </div>
                    <div style="display:flex;align-items:center;justify-content:end;">
                        <div style="width:20px;height:4px;background:linear-gradient(to right,#E4E4E4,transparent);"></div>
                        <div>未授权</div>
                    </div>
                </div>
            </div>
            <div class="fc_gray fs_small">说明: 统一授权所有业务，将使用统一有效期；否则表格中各授权单元格可（开）使用统一有效期、或（关）使用独立有效期，使用独立有效期时「单击」单元格授权/取消、「单击」单元格有效期调整。</div>
            <el-table id="table-bt" :data="gym_bu_rows" style="width: 100%" v-loading="loading" size="mini" class="mb12" @cell-click="switchBuCell">
                <el-table-column type="index" width="60" :index="(index) => index + 1" label="序号" align="center" />
                <el-table-column v-for="(tree,tx) in gym_bu_trees" :key="tx" :prop="tx+'_0'" :label="tree.name" align="center">
                    <el-table-column v-if="tree.subs && tree.subs.length>0" v-for="(sub,sx) in tree.subs" :key="tx+'_'+sx" :prop="tx+'_'+sx" :label="sub.name" align="center">
                        <template slot-scope="scope">
                            <div v-if="scope.row[tx+'_'+sx]" style="padding:2px;line-height:1.5;text-align:left;">
                                <div>{{scope.row[tx+'_'+sx].name}}</div>
                                <div v-if="1!=scope.row[tx+'_'+sx].status" class="fc_red_light fs_tiny" style="line-height:1;font-size:10px;position:absolute;top:1px;right:1px;">{{7==scope.row[tx+'_'+sx].status?'开发中':9==scope.row[tx+'_'+sx].status?'规划中':''}}</div>
                                <div v-if="gym_bu_auth_isallin" style="display:flex;align-items:center;justify-content:space-between;">
                                    <div style="width:20px;height:4px;" :style="{'background':'linear-gradient(to right,'+(gym_bu_auth_dt>=today_zero_dt?'green':'red')+',transparent)'}"></div>
                                    <div :class="gym_bu_auth_dt>=today_zero_dt?'':'fc_red'">{{gym_bu_auth_dt | formatDateShort}}</div>
                                </div>
                                <div v-else-if="gym_bu_auth_dt_isuse" style="display:flex;align-items:center;justify-content:space-between;">
                                    <div style="width:20px;height:4px;" :style="{'background':'linear-gradient(to right,'+((scope.row[tx+'_'+sx].auth_info && 1==scope.row[tx+'_'+sx].auth_info.status)?(gym_bu_auth_dt>=today_zero_dt?'green':'red'):'#E4E4E4')+',transparent)'}"></div>
                                    <div v-if="scope.row[tx+'_'+sx].auth_info && 1==scope.row[tx+'_'+sx].auth_info.status" :class="gym_bu_auth_dt>=today_zero_dt?'':'fc_red'" @click="toExpBuCell($event,scope.$index,tx+'_'+sx)">{{gym_bu_auth_dt | formatDateShort}}</div>
                                </div>
                                <div v-else style="display:flex;align-items:center;justify-content:space-between;">
                                    <div style="width:20px;height:4px;" :style="{'background':'linear-gradient(to right,'+((scope.row[tx+'_'+sx].auth_info && 1==scope.row[tx+'_'+sx].auth_info.status)?(scope.row[tx+'_'+sx].auth_info.expire_dt>=today_zero_dt?'green':'red'):'#E4E4E4')+',transparent)'}"></div>
                                    <div v-if="scope.row[tx+'_'+sx].auth_info && 1==scope.row[tx+'_'+sx].auth_info.status" :class="scope.row[tx+'_'+sx].auth_info.expire_dt>=today_zero_dt?(scope.row[tx+'_'+sx].auth_info.expire_dt==gym_bu_auth_dt?'fc_darken':'fc_gray'):'fc_red'" @click="toExpBuCell($event,scope.$index,tx+'_'+sx)">{{scope.row[tx+'_'+sx].auth_info.expire_dt | formatDateShort}}</div>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <template slot-scope="scope">
                        <div v-if="scope.row[tx+'_0']" style="padding:2px;line-height:1.5;text-align:left;">
                            <div>{{scope.row[tx+'_0'].name}}</div>
                            <div v-if="1!=scope.row[tx+'_0'].status" class="fc_red_light fs_tiny" style="line-height:1;font-size:10px;position:absolute;top:1px;right:1px;">{{7==scope.row[tx+'_0'].status?'开发中':9==scope.row[tx+'_0'].status?'规划中':''}}</div>
                            <div v-if="gym_bu_auth_isallin" style="display:flex;align-items:center;justify-content:space-between;">
                                <div style="width:20px;height:4px;" :style="{'background':'linear-gradient(to right,'+(gym_bu_auth_dt>=today_zero_dt?'green':'red')+',transparent)'}"></div>
                                <div :class="gym_bu_auth_dt>=today_zero_dt?'':'fc_red'">{{gym_bu_auth_dt | formatDateShort}}</div>
                            </div>
                            <div v-else-if="gym_bu_auth_dt_isuse" style="display:flex;align-items:center;justify-content:space-between;">
                                <div style="width:20px;height:4px;" :style="{'background':'linear-gradient(to right,'+((scope.row[tx+'_0'].auth_info && 1==scope.row[tx+'_0'].auth_info.status)?(gym_bu_auth_dt>=today_zero_dt?'green':'red'):'#E4E4E4')+',transparent)'}"></div>
                                <div v-if="scope.row[tx+'_0'].auth_info && 1==scope.row[tx+'_0'].auth_info.status" :class="gym_bu_auth_dt>=today_zero_dt?'':'fc_red'" @click="toExpBuCell($event,scope.$index,tx+'_0')">{{gym_bu_auth_dt | formatDateShort}}</div>
                            </div>
                            <div v-else style="display:flex;align-items:center;justify-content:space-between;">
                                <div style="width:20px;height:4px;" :style="{'background':'linear-gradient(to right,'+((scope.row[tx+'_0'].auth_info && 1==scope.row[tx+'_0'].auth_info.status)?(scope.row[tx+'_0'].auth_info.expire_dt>=today_zero_dt?'green':'red'):'#E4E4E4')+',transparent)'}"></div>
                                <div v-if="scope.row[tx+'_0'].auth_info && 1==scope.row[tx+'_0'].auth_info.status" :class="scope.row[tx+'_0'].auth_info.expire_dt>=today_zero_dt?(scope.row[tx+'_0'].auth_info.expire_dt==gym_bu_auth_dt?'fc_darken':'fc_gray'):'fc_red'" @click="toExpBuCell($event,scope.$index,tx+'_0')">{{scope.row[tx+'_0'].auth_info.expire_dt | formatDateShort}}</div>
                            </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <el-dialog width='25%' :title="'独立配置 '+gym_bu_cellexp_name+' 有效期'" :visible.sync="show_gym_bu_cellexp" append-to-body>
                <div style="display:flex;align-items:center;justify-content:center;">
                    <el-date-picker v-model="gym_bu_auth_cellexp_dtm" type="date" :clearable="false" placeholder="有效期" style="margin-right:10px;"></el-date-picker>
                    <el-button type="primary" @click="doExpBuCell()">确定</el-button>
                </div>
            </el-dialog>
            <div style="margin-top:50px;display: flex;align-items: center;justify-content: flex-end;">
                <el-button plain @click="show_gym_bu=false;">取消</el-button>
                <el-button type="primary" @click="doSetGymBus">保存</el-button>
            </div>
        </el-dialog>

        <el-dialog class="form-wrap" title="连锁排序" :visible.sync="show_sort_gyms">
            <div class="fc_red fs_small">注：红色代表连锁总部。</div>
            <div class="bc_golden_bright" style="border-radius:5px;display: flex;align-items: center;justify-content: flex-start;flex-wrap: wrap;">
                <div id="sort-gyms" style="display: flex;align-items: center;justify-content: flex-start;flex-wrap: wrap;"></div>
            </div>
            <div style="margin-top:50px;display: flex;align-items: center;justify-content: flex-end;">
                <el-button plain @click="show_sort_gyms=false;">取消</el-button>
                <el-button type="primary" @click="doSortGroupGyms">保存排序</el-button>
            </div>
        </el-dialog>

    </div>
</template>
<script>
    import {
        hex,
        hex_hmac
    } from "@/utils/hex.js"
    import {
        randStr
    } from "@/utils/formatData"
    import {
        mapState,
        mapActions
    } from 'vuex'
    import GymVue from "../auth/Gym.vue"
    import Sortable from 'sortablejs'
    const defaultGym = {
        name: '',
        group_sn: '',
        is_flagship: 0,
        tel_no: '',
        tel_name: ''
    }
    const defaultMobSu = {}
    const defaultSu = {}
    export default {
        name: "root_gym",
        data() {
            return {
                today_zero_dt: 0,

                cdit: "",
                loading: false,
                list: [],
                status: 1,
                total: 0,
                page_ix: 1,
                page_size: 50,
                page_size_opts: [5, 10, 25, 50, 100, 250, 500],

                gymOnSet: {
                    ...defaultGym
                },
                showAddModal: false,
                showSetModal: false,
                rule: {
                    name: [{
                        required: true,
                        message: '请输入场馆名称',
                        trigger: ['blur', 'change']
                    }],
                    group_sn: [{
                        validator: (rule, value, callback) => {
                            if (value.length >= 0 && value.length < 21) {
                                callback();
                            } else {
                                callback(new Error('品牌名称20字以内'));
                            }
                        },
                        trigger: ['blur', 'change']
                    }],
                    tel_no: [{
                        required: true,
                        message: '请输入场馆联系电话',
                        trigger: ['blur', 'change']
                    }, {
                        validator: (rule, value, callback) => {
                            if (/^1\d{10}$|^(0\d{2,3}-?|\(0\d{2,3}\))?[1-9]\d{4,7}(-\d{1,8})?$/.test(value)) {
                                callback();
                            } else {
                                callback(new Error('请输入正确的手机号'));
                            }
                        },
                        trigger: ['blur', 'change']
                    }],
                    tel_name: [{
                        required: true,
                        message: '请输入场馆联系人',
                        trigger: ['blur', 'change']
                    }]
                },

                bu_gym: '',
                gym_bu_blocks: [],
                gym_bu_blocks_obj: [],
                show_gym_bu: false,
                gym_bu_trees: [],
                gym_bu_rows: [],
                gym_bu_auth_isallin: false,
                gym_bu_auth_dt: 0,
                gym_bu_auth_dtm: 0,
                gym_bu_auth_dt_isuse: false,
                show_gym_bu_cellexp: false,
                gym_bu_cellexp_rx: -1,
                gym_bu_cellexp_key: '',
                gym_bu_cellexp_name: '',
                gym_bu_auth_cellexp_dtm: 0,

                show_sort_gyms: false,
                sort_gyms_id: [],

                showModalMobSu: false,
                mgu_id_mob_su: 0,
                user_id_mob_su: 0,
                gym_id_mob_su: 0,
                mob_su_list: [],
                mob_su_searched_no: '',
                mob_su_searched_str: '',
                mobSuOnSet: {
                    ...defaultMobSu
                },
                rule_mob_su: {
                    name: [{
                        required: true,
                        message: '请输入手机端超级员工姓名',
                        trigger: ['blur', 'change']
                    }],
                    phoneno: [{
                        required: true,
                        message: '请输入手机端超级员工手机号',
                        trigger: ['blur', 'change']
                    }, {
                        validator: (rule, value, callback) => {
                            if (/^1[3456789]\d{9}$/.test(value)) {
                                callback();
                            } else {
                                callback(new Error('请输入正确的手机号'));
                            }
                        },
                        trigger: ['blur', 'change']
                    }],
                },

                showAddModalSu: false,
                showSetModalSu: false,
                gym_id_su: 0,
                suOnSet: {
                    ...defaultSu
                },
                rule_su: {
                    name: [{
                        required: true,
                        message: '请输入超管姓名',
                        trigger: ['blur', 'change']
                    }],
                    phoneno: [{
                        required: true,
                        message: '请输入超管手机号',
                        trigger: ['blur', 'change']
                    }, {
                        validator: (rule, value, callback) => {
                            if (/^1[3456789]\d{9}$/.test(value)) {
                                callback();
                            } else {
                                callback(new Error('请输入正确的手机号'));
                            }
                        },
                        trigger: ['blur', 'change']
                    }],
                }
            }
        },
        computed: {
            ...mapState(["user"]),
            showModal() {
                return this.showAddModal || this.showSetModal;
            },
            pageStart() {
                return (this.page_ix - 1) * this.page_size;
            },
            showModalSu() {
                return this.showAddModalSu || this.showSetModalSu;
            }
        },
        mounted() {
            this.getList()

            document.body.ondrop = function(event) {
                event.preventDefault()
                event.stopPropagation()
            }
        },
        methods: {
            getList() {
                this.loading = true;
                this.$post("/admin/Root/queryGym", {
                        user_id: this.user.id,
                        cdit: this.cdit,
                        status: this.status,
                        page_ix: this.page_ix,
                        page_size: this.page_size,
                    })
                    .then((res) => {
                        if (res.rst == 0) {
                            res = res.data
                            this.list = res.data
                            this.total = res.total
                        }
                    })
                    .finally(() => {
                        this.loading = false;
                    })
            },
            onSearchClick() {
                this.page_ix = 1
                this.getList()
            },
            onPageSizeChange(page) {
                this.page_size = page
                this.onSearchClick()
            },
            onPageChange(page) {
                this.page_ix = page
                this.getList()
            },
            goSet(gym) {
                this.gymOnSet = {
                    ...gym
                }
                this.showSetModal = true
            },
            onSave() {
                this.$refs['gym-form'].validate((valid) => {
                    if (valid) {
                        this.$confirm("该操作将保存场馆内容，是否继续?", "提示", {
                            confirmButtonText: "确定",
                            cancelButtonText: "取消",
                            type: "info",
                        }).then(() => {
                            let _data = {};
                            if (this.showModal) {
                                _data.name = this.gymOnSet.name || ""
                                _data.tel_no = this.gymOnSet.tel_no || ""
                                _data.tel_name = this.gymOnSet.tel_name || ""
                            }
                            if (this.showSetModal) {
                                _data.gym_id = this.gymOnSet.id
                            }
                            if (this.showAddModal && 1 == this.gymOnSet.is_flagship) {
                                if (!this.gymOnSet.group_name) {
                                    this.$message({
                                        message: '创建连锁总部必须输入品牌名',
                                        type: 'warning'
                                    })
                                    return
                                }
                                _data['is_flagship'] = this.gymOnSet.is_flagship
                                _data['group_name'] = this.gymOnSet.group_name
                                _data['group_new'] = 1
                            }
                            this.$post("/admin/Root/saveGym", _data).then((res) => {
                                if (res.rst == 0) {
                                    this.getList();
                                    this.onCloseModal();
                                }
                            }).finally(() => {
                                this.loading = false;
                            })
                        });
                    }
                });
            },
            handleGymStatus(gym_id, status) {
                this.$confirm("该操作将" + (0 == status ? "删除" : (1 == status ? "恢复" : "")) + "所选场馆，是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "info",
                }).then(() => {
                    this.$post("/admin/Root/saveGym", {
                        gym_id,
                        status,
                    }).finally(() => {
                        this.getList();
                    });
                });
            },
            onCloseModal() {
                this.showAddModal = false
                this.showSetModal = false
                this.gymOnSet = {
                    ...defaultGym
                }
            },
            newGroup(gym_id) {
                if (0 > gym_id) {
                    return
                }
                this.$prompt('请输入品牌总部名称，并创建总部。', "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    inputValue: '',
                    inputPattern: /^.{1,20}$/,
                    inputErrorMessage: '总部品牌名称在1~20字以内',
                    type: "info",
                }).then(({
                    value
                }) => {
                    this.$confirm('创建总部后为连锁提供支持，将不能删除，确认创建?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.$post("/admin/Root/saveGym", {
                            gym_id: gym_id,
                            group_new: 1,
                            group_name: value
                        }).then((res) => {
                            this.getList();
                        })
                    })
                })
            },
            inGroup(gym_id) {
                if (0 > gym_id) {
                    return
                }
                this.$prompt('请输入品牌认证码，加入连锁得到总部支持。', "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    inputValue: '',
                    inputPattern: /^.{4,20}$/,
                    inputErrorMessage: '认证码在4~20字以内',
                    type: "info",
                }).then(({
                    value
                }) => {
                    this.$post("/admin/Root/saveGym", {
                        gym_id: gym_id,
                        group_in: 1,
                        group_sn: value
                    }).then((res) => {
                        this.getList();
                    })
                })
            },
            outGroup(gym_id) {
                if (0 >= gym_id) {
                    return
                }
                this.$confirm("退出场馆所在连锁品牌将不可撤销，是否退出?", "提示", {
                    confirmButtonText: "退出",
                    cancelButtonText: "取消",
                    type: "info",
                }).then(() => {
                    let _data = {
                        gym_id: gym_id,
                        group_out: 1
                    };
                    this.$post("/admin/Root/saveGym", _data).then((res) => {
                        if (res.rst == 0) {
                            this.getList();
                            //this.onCloseModal();
                        }
                    })
                })
            },
            changeGroupName(gym_id, group_name, is_flagship) {
                if (!gym_id || !group_name) {
                    return
                }
                const prompt_txt = (is_flagship && 1 == is_flagship) ? '该操作将修改所有连锁场馆品牌名，且不可撤销，确认修改?' : '该操作仅修改本场馆品牌名，且不可撤销，确认修改?'
                this.$prompt(prompt_txt, "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    inputValue: group_name,
                    inputPattern: /^.{1,20}$/,
                    inputErrorMessage: '品牌名在20字以内',
                    type: "info",
                }).then(({
                    value
                }) => {
                    let _data = {
                        gym_id: gym_id,
                        group_name: value
                    }
                    if (is_flagship && 1 == is_flagship) {
                        _data['isset_flags'] = 1
                    }
                    this.$post("/admin/Root/saveGym", _data).then((res) => {
                        if (res.rst == 0) {
                            this.getList();
                        }
                    })
                })
            },
            goOutFlagship(gym_id) {
                if (0 >= gym_id) {
                    return
                }
                this.$confirm("警告：关闭总部将废弃所有对连锁场馆对支持，确认废弃?", "提示", {
                    confirmButtonText: "确认",
                    cancelButtonText: "取消",
                    type: "info",
                }).then(() => {
                    this.$confirm("再次警告：关闭总部将废弃所有对连锁场馆对支持，确认废弃?", "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "info",
                    }).then(() => {
                        let _data = {
                            gym_id: gym_id,
                            group_out: 1
                        };
                        this.$post("/admin/Root/saveGym", _data).then((res) => {
                            if (res.rst == 0) {
                                this.getList();
                                this.onCloseModal();
                            }
                        })
                    })
                })
            },
            toSetGymBus(gym_id = 0) {
                this.bu_gym = ''
                this.gym_bu_blocks = []
                this.gym_bu_blocks_obj = {}
                this.gym_bu_trees = []
                this.gym_bu_rows = []
                const that = this
                this.$post("/admin/Root/getGymBusiUnitsInfo", {
                    gym_id: gym_id
                }).then((res) => {
                    if (res.rst == 0) {
                        res = res.data
                        that.today_zero_dt = res.today_zero_dt
                        that.bu_gym = res.gym
                        that.gym_bu_auth_isallin = 1 == that.bu_gym.busiunit_auth_isallin ? true : false
                        if (that.bu_gym.busiunit_auth_expire_dt > 0) {
                            that.gym_bu_auth_dt = that.bu_gym.busiunit_auth_expire_dt
                            that.gym_bu_auth_dtm = 1000 * that.bu_gym.busiunit_auth_expire_dt
                        } else {
                            that.gym_bu_auth_dt = that.today_zero_dt + 86400 * 31 - 1
                            that.gym_bu_auth_dtm = 1000 * that.gym_bu_auth_dt
                        }
                        that.gym_bu_blocks = res.busiunit_blocks
                        that.gym_bu_blocks.forEach(block => {
                            that.gym_bu_blocks_obj[block.no] = block
                        })
                        that.gym_bu_trees = res.busiunits_trees
                        let rowc = 0
                        let cols_key = []
                        that.gym_bu_trees.forEach((tree, tx) => {
                            if (tree.subs && tree.subs.length > 0) {
                                tree.subs.forEach((sub, sx) => {
                                    cols_key.push(tx + '_' + sx)
                                    if (sub.busiunits && sub.busiunits.length > rowc) {
                                        rowc = sub.busiunits.length
                                    }
                                })
                            } else {
                                cols_key.push(tx + '_0')
                                if (tree.busiunits && tree.busiunits.length > rowc) {
                                    rowc = tree.busiunits.length
                                }
                            }
                        })
                        for (let rx = 0; rx < rowc; ++rx) {
                            let row = {}
                            cols_key.forEach((col_key, cx) => {
                                row[col_key] = ''
                            })
                            that.gym_bu_rows.push(row)
                        }
                        let bu_auths = {}
                        res.busiunit_auths.forEach((auth, ax) => {
                            bu_auths[auth.type + '_' + auth.no] = auth
                        })
                        that.gym_bu_trees.forEach((tree, tx) => {
                            if (tree.subs && tree.subs.length > 0) {
                                tree.subs.forEach((sub, sx) => {
                                    if (sub.busiunits && sub.busiunits.length > 0) {
                                        sub.busiunits.forEach((bu, bx) => {
                                            that.gym_bu_rows[bx][tx + '_' + sx] = { ...bu, auth_info: bu_auths[bu.type + '_' + bu.no] ? bu_auths[bu.type + '_' + bu.no] : '' }
                                        })
                                    }
                                })
                            } else if (tree.busiunits && tree.busiunits.length > 0) {
                                tree.busiunits.forEach((bu, bx) => {
                                    that.gym_bu_rows[bx][tx + '_0'] = { ...bu, auth_info: bu_auths[bu.type + '_' + bu.no] ? bu_auths[bu.type + '_' + bu.no] : '' }
                                })
                            }
                        })
                    }
                })
                this.show_gym_bu = true
            },
            selectBuBlocks(no = '') {
                if (!no) {
                    return
                }
                if (this.gym_bu_auth_isallin) {
                    this.$message.error('已选择统一授权所有业务，无法独立授权。')
                    return
                }
                if ('all' === no || 'none' === no || 'reverse' === no) {
                    if ('all' === no) {
                        let count = 0
                        let total = 0
                        this.gym_bu_rows.forEach((row, rx) => {
                            Object.values(row).forEach((col, cx) => {
                                if (col) {
                                    if (col.auth_info) {
                                        if (1 != col.auth_info.status) {
                                            col.auth_info.status = 1
                                            count++
                                        }
                                    } else {
                                        col.auth_info = {
                                            status: 1,
                                            type: col.type,
                                            no: col.no,
                                            expire_dt: this.gym_bu_auth_dt
                                        }
                                        count++
                                    }
                                    total++
                                }
                            })
                        })
                        this.$message('增选业务功能 ' + count + '/' + total + '项')
                    } else if ('none' === no) {
                        let count = 0
                        let total = 0
                        this.gym_bu_rows.forEach((row, rx) => {
                            Object.values(row).forEach((col, cx) => {
                                if (col) {
                                    if (col.auth_info) {
                                        if (1 == col.auth_info.status) {
                                            col.auth_info.status = 0
                                            count++
                                        }
                                    }
                                    total++
                                }
                            })
                        })
                        this.$message('不选业务功能 ' + count + '/' + total + '项')
                    } else if ('reverse' === no) {
                        let count = 0
                        let count_2 = 0
                        let total = 0
                        this.gym_bu_rows.forEach((row, rx) => {
                            Object.values(row).forEach((col, cx) => {
                                if (col) {
                                    if (col.auth_info) {
                                        if (1 != col.auth_info.status) {
                                            col.auth_info.status = 1
                                            count++
                                        } else {
                                            col.auth_info.status = 0
                                            count_2++
                                        }
                                    } else {
                                        col.auth_info = {
                                            status: 1,
                                            type: col.type,
                                            no: col.no,
                                            expire_dt: this.gym_bu_auth_dt
                                        }
                                        count++
                                    }
                                    total++
                                }
                            })
                        })
                        this.$message('选择业务功能 ' + count + '/' + total + '项 不选 ' + count_2 + '/' + total + '项')
                    }
                } else {
                    let count = 0
                    let total = 0
                    let bus_rx_ck_obj = {}
                    this.gym_bu_rows.forEach((row, rx) => {
                        Object.keys(row).forEach(ck => {
                            if (row[ck]) {
                                bus_rx_ck_obj[row[ck].type + '_' + row[ck].no] = { rx: rx, ck: ck }
                                total++
                            }
                        })
                    })
                    if (this.gym_bu_blocks_obj[no] && this.gym_bu_blocks_obj[no].busiunits && this.gym_bu_blocks_obj[no].busiunits.length > 0) {
                        this.gym_bu_blocks_obj[no].busiunits.forEach(bu => {
                            if (bus_rx_ck_obj[bu.type + '_' + bu.no] && this.gym_bu_rows[bus_rx_ck_obj[bu.type + '_' + bu.no].rx][bus_rx_ck_obj[bu.type + '_' + bu.no].ck]) {
                                if (this.gym_bu_rows[bus_rx_ck_obj[bu.type + '_' + bu.no].rx][bus_rx_ck_obj[bu.type + '_' + bu.no].ck].auth_info) {
                                    if (1 != this.gym_bu_rows[bus_rx_ck_obj[bu.type + '_' + bu.no].rx][bus_rx_ck_obj[bu.type + '_' + bu.no].ck].auth_info.status) {
                                        this.gym_bu_rows[bus_rx_ck_obj[bu.type + '_' + bu.no].rx][bus_rx_ck_obj[bu.type + '_' + bu.no].ck].auth_info.status = 1
                                        count++
                                    }
                                } else {
                                    this.gym_bu_rows[bus_rx_ck_obj[bu.type + '_' + bu.no].rx][bus_rx_ck_obj[bu.type + '_' + bu.no].ck].auth_info = {
                                        status: 1,
                                        type: bu.type,
                                        no: bu.no,
                                        expire_dt: this.gym_bu_auth_dt
                                    }
                                    count++
                                }
                            }
                        })
                    }
                    this.$message('增选业务功能 ' + count + '/' + total + '项')
                }
            },
            switchBuAuthAllin() {
                this.gym_bu_auth_isallin = !this.gym_bu_auth_isallin
            },
            changeBuAuthDt() {
                this.gym_bu_auth_dt = Math.floor(this.gym_bu_auth_dtm / 1000)
            },
            switchBuCell(row, col, cell, e) {
                if (this.gym_bu_auth_isallin) {
                    this.$message.error('已选择统一授权所有业务，无法单独授权。')
                    return
                }
                if (row[col.property]) {
                    if (!row[col.property].auth_info) {
                        row[col.property].auth_info = {
                            status: 1,
                            type: row[col.property].type,
                            no: row[col.property].no,
                            expire_dt: this.gym_bu_auth_dt
                        }
                    } else {
                        row[col.property].auth_info.status = ++row[col.property].auth_info.status % 2
                    }
                }
            },
            toExpBuCell(e, row_ix = -1, key = '') {
                e.stopPropagation()
                if (0 > row_ix || !this.gym_bu_rows || !this.gym_bu_rows[row_ix] || !this.gym_bu_rows[row_ix][key] || !this.gym_bu_rows[row_ix][key].auth_info || 1 != this.gym_bu_rows[row_ix][key].auth_info.status) {
                    return
                }
                if (this.gym_bu_auth_isallin) {
                    this.$message.error('已选择统一授权所有业务，无法单独调整有效期。')
                    return
                }
                if (this.gym_bu_auth_dt_isuse) {
                    this.$message.error('已使用统一授权有效期，无法单独调整有效期。')
                    return
                }
                this.gym_bu_cellexp_rx = row_ix
                this.gym_bu_cellexp_key = key
                this.gym_bu_cellexp_name = this.gym_bu_rows[row_ix][key].name
                this.gym_bu_auth_cellexp_dtm = 1000 * this.gym_bu_rows[row_ix][key].auth_info.expire_dt
                this.show_gym_bu_cellexp = true
            },
            doExpBuCell() {
                this.gym_bu_rows[this.gym_bu_cellexp_rx][this.gym_bu_cellexp_key].auth_info.expire_dt = Math.floor(this.gym_bu_auth_cellexp_dtm / 1000)
                this.gym_bu_cellexp_rx = -1
                this.gym_bu_cellexp_key = ''
                this.gym_bu_cellexp_name = ''
                this.gym_bu_auth_cellexp_dtm = 0
                this.show_gym_bu_cellexp = false
            },
            doSetGymBus() {
                if (!this.bu_gym || 1 > this.bu_gym.id) {
                    return
                }
                let _data = {
                    gym_id: this.bu_gym.id
                }
                if (this.gym_bu_auth_isallin) {
                    if (1 > this.gym_bu_auth_dt) {
                        this.$message.error('统一授权所有业务 有效期错误')
                        return
                    }
                    _data['busiunit_auth_isallin'] = 1
                    _data['busiunit_auth_expire_dt'] = this.gym_bu_auth_dt
                } else {
                    if (!this.gym_bu_rows) { // 可以是length==0、删除
                        return
                    }
                    if (this.gym_bu_auth_dt_isuse && 1 > this.gym_bu_auth_dt) {
                        this.$message.error('统一授权有效期错误')
                        return
                    }
                    _data['busiunit_auth_isallin'] = 0
                    let busiunit_auths = []
                    if (this.gym_bu_auth_dt_isuse) {
                        _data['busiunit_auth_expire_dt'] = this.gym_bu_auth_dt
                        this.gym_bu_rows.forEach((row, rx) => {
                            Object.values(row).forEach((col, cx) => {
                                if (col.auth_info && 1 == col.auth_info.status) {
                                    busiunit_auths.push({
                                        type: col.type,
                                        no: col.no,
                                        expire_dt: this.gym_bu_auth_dt
                                    })
                                }
                            })
                        })
                    } else {
                        _data['busiunit_auth_expire_dt'] = 0
                        this.gym_bu_rows.forEach((row, rx) => {
                            Object.values(row).forEach((col, cx) => {
                                if (col.auth_info && 1 == col.auth_info.status && col.auth_info.expire_dt > 0) {
                                    busiunit_auths.push({
                                        type: col.type,
                                        no: col.no,
                                        expire_dt: col.auth_info.expire_dt
                                    })
                                }
                            })
                        })
                    }
                    _data['busiunit_auths'] = JSON.stringify(busiunit_auths)
                }
                this.$confirm('更改业务授权将不可撤销, 确认更改?', '警告', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$post("/admin/Root/saveGymBusiUnitAuths", _data).then((res) => {
                        if (res.rst == 0) {
                            this.getList()
                            this.show_gym_bu = false
                        }
                    })
                }).catch(() => {})
            },
            toSortGroupGyms(flagship_id = 0) {
                if (0 >= flagship_id) {
                    return
                }
                this.show_sort_gyms = true
                this.sort_gyms_id = []
                const that = this
                this.$post("/admin/Root/getGroupGyms", {
                    flagship_id: flagship_id
                }).then((res) => {
                    if (res.rst == 0) {
                        const sortGyms = document.getElementById('sort-gyms')
                        sortGyms.innerHTML = ''
                        res.data.forEach(item => {
                            that.sort_gyms_id.push(item.id)
                            const div = document.createElement('div')
                            div.textContent = item.name
                            div.setAttribute('data_id', item.id)
                            div.setAttribute('class', 1 == item.is_flagship ? 'bc_red' : 'bc_golden_bright')
                            div.setAttribute('style', 'margin: 10px;padding: 6px 10px;border-radius: 2px;cursor: pointer;')
                            const sub = document.createElement('div')
                            sub.textContent = item.group_name
                            sub.setAttribute('class', 1 == item.is_flagship ? 'fs_tiny fc_light' : 'fs_tiny fc_gray')
                            div.appendChild(sub)
                            sortGyms.appendChild(div)
                        });
                        new Sortable(sortGyms, {
                            animation: 250
                        });
                    }
                })
            },
            doSortGroupGyms(flagship_id = 0) {
                this.$confirm("该操作将更新连锁场馆顺序，且不可撤销，是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "info",
                }).then(() => {
                    const sortGyms = document.getElementById('sort-gyms')
                    let id_sort_pairs = []
                    Array.from(sortGyms.children).forEach((item, ix) => {
                        id_sort_pairs.push({
                            id: item.getAttribute('data_id'),
                            sort: 1 + ix
                        })
                    })
                    this.$post("/admin/Root/resortGroupGyms", {
                        id_sort_pairs: JSON.stringify(id_sort_pairs)
                    }).then(res => {
                        if (res.rst == 0) {
                            this.$message({
                                message: res.msg,
                                type: 0 == res.rst ? 'success' : 'error'
                            })
                            this.getList()
                        }
                    }).finally((res) => {
                        this.show_sort_gyms = false
                    })
                })
            },
            toSetMobSu(gym_id = 0, mob_sus = []) {
                if (1 > gym_id) {
                    return
                }
                this.mob_su_list = mob_sus
                this.gym_id_mob_su = gym_id
                this.mgu_id_mob_su = 0
                this.user_id_mob_su = 0
                this.mob_su_searched_no = ''
                this.mob_su_searched_str = ''
                this.showModalMobSu = true
            },
            getMobSu() {
                this.mgu_id_mob_su = 0
                this.user_id_mob_su = 0
                this.mob_su_searched_no = ''
                this.mob_su_searched_str = ''
                this.mobSuOnSet.name = ''
                const that = this
                this.$refs['mob-su-form'].validate((valid) => {
                    if (valid) {
                        let _data = {};
                        if (that.showModalMobSu) {
                            _data.phoneno = that.mobSuOnSet.phoneno || ""
                            _data.gym_id = that.gym_id_mob_su
                        }
                        that.$post("/admin/Root/getGymMobSuper", _data).then(res => {
                            if (res.rst == 0) {
                                res = res.data
                                this.user_id_mob_su = res.user.id
                                this.mobSuOnSet = {
                                    phoneno: res.user.phoneno,
                                    name: res.user.name
                                }
                                if (0 == res.id) {
                                    this.mob_su_searched_no = 'not_this_gym'
                                    this.mob_su_searched_str = '手机账号本馆不存在，确认添加？'
                                } else {
                                    if (1 == res.is_super) {
                                        this.mob_su_searched_no = 'is_super'
                                        this.mob_su_searched_str = '已经是本馆超级员工'
                                    } else {
                                        this.mgu_id_mob_su = res.id
                                        this.mob_su_searched_no = 'not_super'
                                        this.mob_su_searched_str = '本馆会员' + (1 == res.is_trainer ? '、教练' : '') + (1 == res.is_adminer ? '、员工' : '') + '，设为超级员工？'
                                    }
                                }
                            } else {
                                this.mobSuOnSet = {
                                    phoneno: _data.phoneno,
                                    name: ''
                                }
                                this.mob_su_searched_no = 'not_mgu'
                                this.mob_su_searched_str = '手机账号不存在，确认添加？'
                            }
                        })
                    }
                });
            },
            doSetMobSu() {
                const that = this
                this.$refs['mob-su-form'].validate((valid) => {
                    if (valid) {
                        let _data = {
                            phoneno: that.mobSuOnSet.phoneno || "",
                            name: that.mobSuOnSet.name || ""
                        }
                        if ('is_super' === that.mob_su_searched_no) {
                            that.$alert('已经是本馆超级员工', '提示', {
                                confirmButtonText: '确定',
                            })
                            return
                        } else if ('not_super' === that.mob_su_searched_no) {
                            _data['mgu_id'] = that.mgu_id_mob_su
                            _data['user_id'] = that.user_id_mob_su
                        } else if ('not_this_gym' === that.mob_su_searched_no) {
                            _data['gym_id'] = that.gym_id_mob_su
                            _data['user_id'] = that.user_id_mob_su
                        } else if ('not_mgu' === that.mob_su_searched_no) {
                            that.$alert('手机账号不存在 请打开小程序注册账号后再设置为超级成员！', '警告', {
                                confirmButtonText: '确定',
                            })
                            return
                        }
                        that.$confirm("该操作将设置修改手机端超级员工内容，是否继续?", "提示", {
                            confirmButtonText: "确定",
                            cancelButtonText: "取消",
                            type: "info",
                        }).then(() => {
                            that.$post("/admin/Root/setGymMobSuper", _data).finally(() => {
                                that.getList()
                                that.onCloseModalMobSu();
                            });
                        });
                    }
                });
            },
            doRmMobSu(mgu_id = 0) {
                if (1 > mgu_id) {
                    return
                }
                this.$confirm("该操作将删除所选手机端超级员工，是否继续?", "警告", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                }).then(() => {
                    this.$post("/admin/Root/setGymMobSuper", {
                        mgu_id: mgu_id,
                        is_super: 0
                    }).finally(() => {
                        this.getList()
                        this.onCloseModalMobSu();
                    });
                });
            },
            onCloseModalMobSu() {
                this.showModalMobSu = false
                this.mob_su_list = []
                this.gym_id_mob_su = 0
                this.mgu_id_mob_su = 0
                this.user_id_mob_su = 0
                this.mob_su_searched_no = ''
                this.mob_su_searched_str = ''
                this.mobSuOnSet = {
                    ...defaultMobSu
                }
            },
            goSetSu(su) {
                this.suOnSet = {
                    ...su
                }
                this.showSetModalSu = true
            },
            onSaveSu() {
                const that = this
                this.$refs['su-form'].validate((valid) => {
                    if (valid) {
                        that.$confirm("该操作将保存修改超管内容，是否继续?", "提示", {
                            confirmButtonText: "确定",
                            cancelButtonText: "取消",
                            type: "info",
                        }).then(() => {
                            let _data = {};
                            if (that.showModalSu) {
                                _data.name = that.suOnSet.name || ""
                                _data.phoneno = that.suOnSet.phoneno || ""
                            }
                            if (that.showAddModalSu) {
                                _data.gym_id = that.gym_id_su
                            } else if (that.showSetModalSu) {
                                _data.ags_id = that.suOnSet.id
                            } else;
                            that.$post("/admin/Root/saveGymSuper", _data).finally(() => {
                                that.getList()
                                that.onCloseModalSu();
                            });
                        });
                    }
                });
            },
            onRemoveSu() {
                this.$confirm("该操作将删除所选超管，是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "info",
                }).then(() => {
                    this.$post("/admin/Root/saveGymSuper", {
                        ags_id: this.suOnSet.id,
                        status: 0
                    }).finally(() => {
                        this.getList()
                        this.onCloseModalSu();
                    });
                });
            },
            onCloseModalSu() {
                this.showAddModalSu = false
                this.showSetModalSu = false
                this.gym_id_su = 0
                this.suOnSet = {
                    ...defaultSu
                }
            },

            resetPW() {
                const pw = randStr(8)
                this.$prompt("该操作将重置登陆密码为 " + pw + "，确认记录后继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    inputValue: pw,
                    inputPattern: /^([0-9A-Za-z_]{6,20})$/,
                    inputErrorMessage: '密码由“6~20位 数字、字母、_”组成',
                    type: "info",
                }).then(({
                    value
                }) => {
                    this.$post("/admin/Root/saveGymSuper", {
                        ags_id: this.suOnSet.id,
                        password: hex_hmac(String(this.suOnSet.phoneno), hex(value))
                    }).finally(() => {
                        this.onCloseModalSu();
                    });
                })
            }
        }
    };
</script>
<style lang="less">
    .gym {
        .toolbar {
            .operation {
                .search-ipt {
                    width: 350px;
                }

                .add-btn {
                    margin-left: 50px;
                }
            }

            .filters {
                margin-left: 50px;
            }
        }

        #btn-adminer-new {
            background: #ea7ccc;
            border-color: #ea7ccc;
            color: white;
        }

        #btn-group-new {
            background: #73c0de;
            border-color: #73c0de;
            color: white;
        }
    }

    #table-bu .el-table__cell {
        padding: 0 !important;

        .cell {
            padding: 0 !important;
        }
    }
</style>